
export default (number) => {
  if (number >= 100 && number < 1000) {
    return `Более ${Math.ceil(number / 10) * 10} лучших`;
  }
  else if (number >= 1000) {
    return `Более ${Math.ceil(number / 100) * 100} лучших`;
  }
  else {
    return 'Лучшее из';
  }
};
